<template>
  <div class="dialog">
    <span class="cls" @click="oth_showMyAssets(false)"></span>
    <div class="paper">
      <div class="header">
        <h2>내자산 <span class="subtitle">고객 관리에 사용하는 자산</span></h2>
        <span @click="oth_showMyAssets(false)">
          <i class="ph ph-x"></i>
        </span>
      </div>

      <div class="content">
        <!-- 상단 3개 카드 -->
        <div class="top-cards">
          <div class="asset-card ticket">
            <i class="ph-fill ph-ticket"></i>
            <span class="label">뽑기권</span>
            <div class="value">{{ assets.tickets }} <span class="unit">장</span></div>
            <button class="action-btn" @click="handleAddTicket">추가</button>
          </div>

          <div class="asset-card point">
            <i class="ph-fill ph-circle"></i>
            <span class="label">포인트</span>
            <div class="value">{{ formatNumber(assets.points) }} <span class="unit">P</span></div>
            <button class="action-btn" @click="handleChargePoint">충전</button>
          </div>

          <div class="asset-card gift" @click="handleViewGiftHistory">
            <i class="ph-fill ph-gift"></i>
            <span class="label">선물</span>
            <div class="value">보유중 <span class="count">{{ assets.gifts }}</span></div>
            <button class="action-btn" @click.stop="handleSendGift">보내기</button>
          </div>
        </div>

        <!-- 하단 2개 큰 카드 -->
        <div class="bottom-cards">
          <div class="feature-card roulette" @click="handleOpenRoulette">
            <div class="roulette-glow"></div>
            <div class="roulette-content">
              <!-- 룰렛 휠 -->
              <div class="roulette-wheel-wrap">
                <img src="/imgs/common/roulette.png" class="roulette-image" />
                
                <!-- 중앙 캐릭터 -->
                <div class="roulette-center">
                  <img src="https://amadiary.com/pub/edit_icon/chara_moneybag.png" class="center-character">
                </div>
                
                <!-- 행운의 뽑기 뱃지 -->
                <div class="lucky-badge">
                  <span>🍀</span>
                  <p>행운의<br>뽑기</p>
                </div>
                
                <!-- 화살표 포인터 -->
                <div class="roulette-pointer">
                  <svg width="24" height="30" viewBox="0 0 40 50">
                    <path d="M20 0 L40 20 L25 20 L25 50 L15 50 L15 20 L0 20 Z" fill="#FFD700" stroke="#FF6B00" stroke-width="2"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div class="feature-card send-gift" @click="handleOpenSendGift">
            <div class="gift-icon">
              <i class="ph-fill ph-gift"></i>
            </div>
            <h3>고객에게<br>선물보내기</h3>
          </div>
        </div>
      </div>
    </div>

    <!-- 선물 내역 다이얼로그 -->
    <giftHistoryDialog 
      v-if="showGiftHistory" 
      :oth_close="() => showGiftHistory = false"
    />
  </div>
</template>

<script>
import { ref, inject, onMounted } from "vue"
import giftHistoryDialog from './giftHistoryDialog.vue'

export default {
  components: {
    giftHistoryDialog
  },
  props: {
    oth_showMyAssets: Function
  },
  setup() {
    const member_info = inject('member_info');
    const sql_query = inject('sql_query');

    const assets = ref({
      tickets: 0,
      points: 0,
      gifts: 0
    })

    const showGiftHistory = ref(false);

    // 포인트 조회
    async function getPoint() {
      let sql = `SELECT point FROM member WHERE mb_id = '${member_info.mb_id}'`;
      let res = await sql_query(sql);
      if (res && res.length > 0) {
        assets.value.points = res[0].point || 0;
      }
    }

    // 뽑기권 조회
    async function getTickets() {
      const sql = `
        SELECT SUM(ticket_count - used_count) as remaining
        FROM roulette_tickets 
        WHERE mb_id = '${member_info.mb_id}' 
        AND status = 'active' 
        AND (expired_at IS NULL OR expired_at > NOW())
        AND ticket_count > used_count
      `;
      const res = await sql_query(sql);
      if (res && res[0]?.remaining) {
        assets.value.tickets = parseInt(res[0].remaining) || 0;
      }
    }

    // 선물(기프트쿠폰) 조회
    async function getGifts() {
      const sql = `
        SELECT COUNT(*) as cnt
        FROM giftcoupon
        WHERE issued_by = '${member_info.mb_id}'
        AND status IN ('발행', '사용대기')
      `;
      const res = await sql_query(sql);
      if (res && res.length > 0) {
        assets.value.gifts = res[0].cnt || 0;
      }
    }

    const formatNumber = (num) => {
      if (num === null || num === undefined) return '0';
      return num.toLocaleString('ko-KR')
    }

    const handleAddTicket = () => {
      console.log('추가 티켓')
    }

    const handleChargePoint = () => {
      console.log('포인트 충전')
    }

    const handleSendGift = () => {
      console.log('선물 보내기')
    }

    const handleViewGiftHistory = () => {
      showGiftHistory.value = true;
    }

    const handleOpenRoulette = () => {
      console.log('룰렛 열기')
    }

    const handleOpenSendGift = () => {
      console.log('고객에게 선물 보내기')
    }

    onMounted(() => {
      getPoint();
      getTickets();
      getGifts();
    })

    return {
      assets,
      showGiftHistory,
      formatNumber,
      handleAddTicket,
      handleChargePoint,
      handleSendGift,
      handleViewGiftHistory,
      handleOpenRoulette,
      handleOpenSendGift,
    }
  }
}
</script>
<style scoped>
.dialog {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--color-surface);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 99;
  backdrop-filter: blur(2px);
}

.dialog > .cls {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

.dialog > .paper {
  width: 90%;
  max-width: 500px;
  height: auto;
  max-height: 85vh;
  background: var(--color-background);
  border: 1px solid var(--color-background-light);
  border-radius: 16px;
  padding: 20px;
  box-sizing: border-box;
  gap: 24px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.paper > .header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.paper > .header > h2 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.paper > .header > h2 > .subtitle {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-normal);
  color: var(--color-text-secondary);
}

.paper > .header > span {
  width: var(--font-size-3xl);
  height: var(--font-size-3xl);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
}

.paper > .header > span > i {
  font-size: var(--font-size-xl);
  color: var(--color-text-primary);
}

/* Content */
.content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

/* Top Cards */
.top-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.asset-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 12px;
  border-radius: 12px;
  position: relative;
}

.asset-card.ticket {
  background: linear-gradient(135deg, #FFF4E6 0%, #FFE8CC 100%);
}

.asset-card.point {
  background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);
}

.asset-card.gift {
  background: linear-gradient(135deg, #FCE4EC 0%, #F8BBD0 100%);
}

.asset-card > i {
  font-size: 32px;
  color: #333;
}

.asset-card.point > i::before {
  content: 'P';
  font-family: 'Arial', sans-serif;
  font-weight: bold;
  font-style: normal;
  border: 3px solid #333;
  border-radius: 50%;
  padding: 4px 8px;
  font-size: 20px;
}

.asset-card > .label {
  font-size: var(--font-size-xs);
  color: #666;
  font-weight: var(--font-weight-medium);
}

.asset-card > .value {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: #000;
  margin: 4px 0;
}

.asset-card > .value > .unit {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-normal);
  margin-left: 2px;
}

.asset-card > .value > .count {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
}

.asset-card > .action-btn {
  width: 100%;
  padding: 6px 12px;
  border: none;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.1);
  color: #333;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all 0.2s;
}

.asset-card > .action-btn:hover {
  background: rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.asset-card > .action-btn:active {
  transform: translateY(0);
}

/* Bottom Cards */
.bottom-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.feature-card {
  aspect-ratio: 1/1;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.feature-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

/* 룰렛 카드 */
.feature-card.roulette {
  background: linear-gradient(135deg, #FF6B00 0%, #FFD700 50%, #FF6B00 100%);
  background-size: 200% 200%;
  animation: gradient-shift 3s ease infinite;
  box-shadow: 
    0 0 20px rgba(255, 215, 0, 0.3),
    0 4px 16px rgba(255, 107, 0, 0.2);
}

@keyframes gradient-shift {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

.roulette-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 120%;
  height: 120%;
  background: radial-gradient(circle, rgba(255, 215, 0, 0.3) 0%, transparent 70%);
  transform: translate(-50%, -50%);
  animation: glow-pulse 2s ease-in-out infinite;
  pointer-events: none;
}

@keyframes glow-pulse {
  0%, 100% { opacity: 0.5; transform: translate(-50%, -50%) scale(1); }
  50% { opacity: 0.8; transform: translate(-50%, -50%) scale(1.1); }
}

.roulette-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.roulette-wheel-wrap {
  position: relative;
  width: 70%;
  aspect-ratio: 1;
  filter: drop-shadow(0 6px 16px rgba(0, 0, 0, 0.3));
}

.roulette-image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.feature-card.roulette:hover .roulette-image {
  animation: roulette-idle-spin 20s linear infinite;
}

@keyframes roulette-idle-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 중앙 캐릭터 */
.roulette-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 45%;
  height: 45%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translate(-50%, -50%) translateY(0px); }
  50% { transform: translate(-50%, -50%) translateY(-6px); }
}

.center-character {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.3));
}

/* 행운의 뽑기 뱃지 */
.lucky-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 
    0 3px 8px rgba(255, 165, 0, 0.5),
    inset 0 0 15px rgba(255, 255, 255, 0.3);
  border: 2px solid #fff;
  animation: badge-bounce 2s ease-in-out infinite;
}

@keyframes badge-bounce {
  0%, 100% { transform: scale(1) rotate(0deg); }
  50% { transform: scale(1.1) rotate(5deg); }
}

.lucky-badge span {
  font-size: 18px;
  line-height: 1;
}

.lucky-badge p {
  margin: 0;
  font-size: 7px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  line-height: 1.1;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* 화살표 포인터 */
.roulette-pointer {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  animation: pointer-bounce 1s ease-in-out infinite;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

@keyframes pointer-bounce {
  0%, 100% { transform: translateX(-50%) translateY(0px); }
  50% { transform: translateX(-50%) translateY(-3px); }
}

/* 선물 보내기 카드 */
.feature-card.send-gift {
  background: linear-gradient(135deg, #80DEEA 0%, #4DD0E1 100%);
}

.gift-icon {
  font-size: 60px;
  margin-bottom: 8px;
  animation: gift-bounce 2s ease-in-out infinite;
}

@keyframes gift-bounce {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-8px); }
}

.gift-icon i {
  color: #fff;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
}

.feature-card h3 {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  color: #fff;
  margin: 0;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  line-height: 1.4;
}

/* 반응형 */
@media (max-width: 480px) {
  .top-cards {
    grid-template-columns: 1fr;
  }

  .asset-card {
    flex-direction: row;
    justify-content: space-between;
    padding: 12px 16px;
  }

  .asset-card > i {
    font-size: 24px;
  }

  .asset-card > .action-btn {
    width: auto;
    padding: 6px 16px;
  }

  .bottom-cards {
    grid-template-columns: 1fr;
  }

  .feature-card {
    aspect-ratio: 2/1;
  }

  .lucky-badge {
    width: 45px;
    height: 45px;
  }

  .lucky-badge span {
    font-size: 16px;
  }

  .lucky-badge p {
    font-size: 6px;
  }
}
</style>